import { gql } from "@apollo/client";
import {
  DepartmentNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
  ProductListFragment,
  ProductNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  LayoutNodeFilter,
  LayoutNodeFilterType,
  Category,
  Department,
  Product,
} from "@towersystems/roam-common/lib/generated-types";
import { PaginatedList } from "@towersystems/roam-common/lib/shared-types";
import { client } from "../apollo";
import { QueryCategories } from "../components/CategoryListScreen/constants";
import { QueryDepartments } from "../components/DepartmentListScreen/constants";

type QueryCategoriesResult = {
  categories: PaginatedList<Category>;
};

type QueryDepartmentsResult = {
  departments: PaginatedList<Department>;
};

type QueryProductsResult = {
  products: PaginatedList<Product>;
};

export const QueryProducts = gql`
  ${ProductListFragment}
  ${PaginatedListMetaNoNestingFragment}
  ${ProductNoNestingFragment}
  query QueryProducts($options: ProductListOptions) {
    products(options: $options) {
      items {
        ...ProductNoNesting
      }
    }
  }
`;

export async function fetchCategoriesByIds(categoryIds: string[]) {
  const { data } = await client.query<QueryCategoriesResult>({
    query: QueryCategories,
    variables: makeFilterVariables(categoryIds),
  });

  return data.categories.items;
}

export async function fetchDepartmentsByIds(departmentIds: string[]) {
  const { data } = await client.query<QueryDepartmentsResult>({
    query: QueryDepartments,
    variables: makeFilterVariables(departmentIds),
  });
  return data.departments.items;
}

export async function fetchProductsByIds(productIds: string[]) {
  const { data } = await client.query<QueryProductsResult>({
    query: QueryProducts,
    variables: makeFilterVariables(productIds),
  });
  return data.products.items;
}

function makeFilterVariables(ids: string[]) {
  return {
    options: {
      limit: 100,
      page: 0,
      filter: {
        id: {
          in: ids,
        },
      },
    },
  };
}
